import * as Alerts from "./Alerts/index.js";
import * as Charting from "./Charting/index.js";
import * as Preferences from "./Preferences/index.js";
/** CoStar.Api.PropertyUser.ImageType */
export var ImageType;
(function (ImageType) {
    ImageType[ImageType["None"] = 0] = "None";
    ImageType[ImageType["Gif"] = 1] = "Gif";
    ImageType[ImageType["Jpg"] = 2] = "Jpg";
    ImageType[ImageType["Png"] = 3] = "Png";
})(ImageType || (ImageType = {}));
/** CoStar.Api.PropertyUser.CompEntityType */
export var CompEntityType;
(function (CompEntityType) {
    CompEntityType[CompEntityType["Unknown"] = 0] = "Unknown";
    CompEntityType[CompEntityType["RentComp"] = 1] = "RentComp";
    CompEntityType[CompEntityType["SaleComp"] = 2] = "SaleComp";
})(CompEntityType || (CompEntityType = {}));
/** CoStar.Api.PropertyUser.SavedTemplateType */
export var SavedTemplateType;
(function (SavedTemplateType) {
    SavedTemplateType[SavedTemplateType["None"] = 0] = "None";
    SavedTemplateType[SavedTemplateType["Demographic"] = 1] = "Demographic";
    SavedTemplateType[SavedTemplateType["Tenant"] = 2] = "Tenant";
})(SavedTemplateType || (SavedTemplateType = {}));
/** CoStar.Api.PropertyUser.EntityType */
export var EntityType;
(function (EntityType) {
    EntityType[EntityType["None"] = 0] = "None";
    EntityType[EntityType["Property"] = 1] = "Property";
    EntityType[EntityType["Tenant"] = 2] = "Tenant";
})(EntityType || (EntityType = {}));
export { Alerts, Charting, Preferences };
